import { setupExperiment } from './setupExperiment'

/**
 * Sent events to Cutlass
 */
export default (app, cannon) => {
  if (!cannon) return
  setupExperiment(app, cannon.visitorId)
}
